import { useEffect, useState } from 'react';
import { LINB_API } from '../../constants/api-urls';
import { pmIntegrationSelector } from 'state/selectors/sensors-authorizations';
import { useSelector } from 'react-redux';
import { normalizePMEntitiesDataFromDDB } from 'views/root/views/home/views/settings/views/ProjectManagement/services/project-management.service';
import { PROVIDERS_MAP } from 'common/constants/constants';
import axios from 'common/requester';
import { SENSOR_STATES } from '@linearb/linjs-common';
import { useDebounceCallback } from '@react-hook/debounce';

export const MAX_LIMIT_FOR_PM_ENTITIES = 20000;
const DEBOUNCE_TIMEOUT = 400;

const useJiraEntities = entityName => {
  const ENTITIES_MAP = {
    [PROVIDERS_MAP.jira.entity_names.board]: 'BOARDS',
    [PROVIDERS_MAP.jira.entity_names.project]: 'PROJECTS',
    [PROVIDERS_MAP.jira.entity_names_plural.board]: 'BOARDS',
    [PROVIDERS_MAP.jira.entity_names_plural.project]: 'PROJECTS'
  };

  const pmSensor = useSelector(pmIntegrationSelector);
  const isAuthorized = pmSensor?.state === SENSOR_STATES.ok;

  const url = `${
    LINB_API.PM_SERVICE.PM_ENTITIES[ENTITIES_MAP[entityName]]
  }?limit=${MAX_LIMIT_FOR_PM_ENTITIES}`;

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchEntities = useDebounceCallback(async () => {
    setData([]);
    try {
      let res;
      setLoading(true);
      if (!isAuthorized) {
        res = [];
      } else {
        res = await axios.get(url);
      }
      const normalizedData = normalizePMEntitiesDataFromDDB(res);

      setData(normalizedData);
    } catch (error) {
      setError(error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, DEBOUNCE_TIMEOUT);
    }
  }, DEBOUNCE_TIMEOUT);

  useEffect(() => {
    setLoading(true);
    fetchEntities();
  }, [entityName]);

  return {
    data,
    loading,
    error
  };
};

export default useJiraEntities;
